module.exports = __webpack_public_path__ + "assets/b9c114ce0205996b5428694bc83523f0.mp4";